/* Vendor_PRICINGGET_VENDOR_PRICING */
export const GET_VENDOR_PRICING = "GET_VENDOR_PRICING"
export const GET_VENDOR_PRICING_SUCCESS = "GET_VENDOR_PRICING_SUCCESS"
export const GET_VENDOR_PRICING_FAIL = "GET_VENDOR_PRICING_FAIL"

/* Vendor_PRICINGGET_VENDOR_PRICING PROFILE */
export const GET_VENDOR_PRICING_PROFILE = "GET_VENDOR_PRICING_PROFILE"
export const GET_VENDOR_PRICING_PROFILE_SUCCESS = "GET_VENDOR_PRICING_PROFILE_SUCCESS"
export const GET_VENDOR_PRICING_PROFILE_FAIL = "GET_VENDOR_PRICING_PROFILE_FAIL"

/**
 * add VENDOR_PRICING
 */
 export const ADD_NEW_VENDOR_PRICING = "ADD_NEW_VENDOR_PRICING"
 export const ADD_VENDOR_PRICING_SUCCESS = "ADD_VENDOR_PRICING_SUCCESS"
 export const ADD_VENDOR_PRICING_FAIL = "ADD_VENDOR_PRICING_FAIL"

 /**
 * Edit VENDOR_PRICING
 */
export const UPDATE_VENDOR_PRICING = "UPDATE_VENDOR_PRICING"
export const UPDATE_VENDOR_PRICING_SUCCESS = "UPDATE_VENDOR_PRICING_SUCCESS"
export const UPDATE_VENDOR_PRICING_FAIL = "UPDATE_VENDOR_PRICING_FAIL"

/**
 * Delete VENDOR_PRICING
 */
export const DELETE_VENDOR_PRICING = "DELETE_VENDOR_PRICING"
export const DELETE_VENDOR_PRICING_SUCCESS = "DELETE_VENDOR_PRICING_SUCCESS"
export const DELETE_VENDOR_PRICING_FAIL = "DELETE_VENDOR_PRICING_FAIL"


